import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
///todo chage class name adding query
export class SolutionEstimateUsersQueryService {

    public CREATE_SOLUTION_ESTIMATE_USERS: any;
  
 

    constructor(public apollo: Apollo) {

        //Create report review detail without categoryid,subcategory id
        this.CREATE_SOLUTION_ESTIMATE_USERS = gql` 
        mutation CREATE_Solution_Estimate_Users($input: CreateSolutionestimateuserInput!) {
            createSolutionestimateuser(input: $input) {
              solutionestimateuser{
                roleid
                orderid
                userid
                reportid
              }

          }
      }
        `;

     
      
    }

    CREATE_SOLUTION_ESTIMATE(orderId, userId, insReportId, roleId) {
        // console.log('allElement', allElement);
        return this.apollo.mutate({
            mutation: this.CREATE_SOLUTION_ESTIMATE_USERS,
            variables: {
                "input": {                   
                    "solutionestimateuser":  {
                        "userid":  userId,
                        "roleid": roleId,
                        "reportid":insReportId,
                        "orderid": orderId,
                        "createdat": new Date()    
                     }
                     
                },
                fetchPolicy: 'cache-first'
            }
        })
    }

   
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/queryFiles/solutionEstimateUsers.ts